import React, { PureComponent } from 'react';
import { PropTypes as RPT } from 'prop-types';

export default class Modal extends PureComponent {
  static propTypes = {
    children: RPT.node,
    modalId: RPT.string,
    title: RPT.string,
  }

  render() {
    const {
      children,
      modalId,
      title,
    } = this.props;

    return (
      <div className="modal fade modal-free-e-book" id={modalId} role="dialog" style={{ display: 'none' }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button className="close" data-dismiss="modal" type="button">×</button>
              <h2 className="modal-title">{title}</h2>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
